// src/components/Button.tsx
import React from "react";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: "primary" | "outline" | "text";
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = "",
  type = "button",
  disabled = false,
  variant = "primary",
  loading = false,
}) => {
  // If the existing button styles are very specific (uppercase, etc), I should try to preserve them for primary.
  // The original was: `w-full p-4 rounded-lg text-white uppercase text-center shadow-button`
  // I will try to match that for primary.
  
  const getClasses = () => {
    if (variant === 'primary') {
        return `w-full p-4 rounded-lg text-white uppercase text-center shadow-button ${className}`;
    }
    if (variant === 'outline') {
        return `w-full p-4 rounded-lg text-gray-700 uppercase text-center border border-gray-300 hover:bg-gray-50 ${className}`;
    }
    return className;
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${getClasses()} ${disabled || loading ? 'opacity-50 cursor-not-allowed' : ''}`}
      disabled={disabled || loading}
    >
      {loading ? (
        <svg className="animate-spin h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
